<template>
    <el-dialog
        ref="DetailDialog"
        :visible="visible"
        :modal-append-to-body="false"
        append-to-body
        class="invoice-arrived-edit-dialog ah-detail-dialog"
        width="600px"
        top="5vh"
        :custom-class="isIncome ? '' : 'danger'"
        :close-on-click-modal="false"
        @open="onOpen"
        @close="onClose"
        @closed="onClosed"
    >
        <template slot="title"> {{ title }} </template>
        <div class="detail-row" style="padding-top: 30px">
            <div class="detail-block">
                <div class="info-block">
                    <div class="total">
                        <div class="title">發票含稅總計</div>
                        <Money :v="invoice.amt" :precision="invoice.cny === 'TWD' ? null : 4" />
                        <div class="cny">{{ invoice.cny }}</div>
                    </div>
                    <div class="current">
                        <div class="title">已收金額</div>
                        <Money :v="totalArrival" :precision="invoice.cny === 'TWD' ? null : 4" />
                        <div class="cny">{{ invoice.cny }}</div>
                    </div>
                </div>
                <el-form ref="form" :rules="rules" :model="form" class="ah-form" label-position="top">
                    <el-form-item prop="receiveIncomeType" :label="`${isIncome ? '入帳' : '退款'}方式`">
                        <el-radio-group v-model="form.receiveIncomeType" class="time-tab">
                            <el-radio-button v-for="item in typeList" :key="item.sno" :label="item.sno" :disabled="isCashOperationDisabled(item.sno)">
                                {{ item.label }}
                            </el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-row :gutter="20">
                        <el-col :sm="9">
                            <el-form-item prop="bnK_DAT" :label="`${isIncome ? '入帳' : '退款'}日期`">
                                <el-date-picker v-model="form.bnK_DAT" value-format="timestamp" type="date" placeholder="選擇日期" style="width: 100%" :picker-options="{ disabledDate }">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="15">
                            <el-form-item v-if="isBankShow" prop="bnK_SNO" :label="`${isIncome ? '存入' : '退款'}帳戶`">
                                <ah-el-select-bank-account v-model="form.bnK_SNO" document-type="invoice" :cny="invoice.cny" hide-borrower></ah-el-select-bank-account>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :sm="isTWD ? 24 : 16">
                            <el-form-item prop="amount">
                                <template slot="label">
                                    <span>本次{{ isIncome ? "收款" : "退款" }}金額 </span>
                                    <span v-if="isIncome" style="font-size: 9pt; color: #ff4747; margin: -18px 0 0 10px;">
                                        應與發票金額相符
                                    </span>
                                </template>
                                <MoneyInput v-model="form.amount" :prepend="isIncome ? null : '–'" :precision="isTWD ? 0 : 4" :suffix="invoice.cny"></MoneyInput>
                            </el-form-item>
                            <div style="font-size: 9pt; color: #ff4747; margin-bottom: 15px;">如有匯費請至 <strong> 『財務 / 銀行匯款明細、匯費』 </strong>中新增</div>
                        </el-col>
                        <el-col :sm="8">
                            <el-form-item v-if="!isTWD" prop="rat">
                                <template slot="label">
                                    匯率
                                    <el-button size="mini" @click="applySysCnyRat(invoice.cny)" style="padding: 5px 8px; margin-left: 8px">即時匯率</el-button>
                                </template>
                                <MoneyInput v-model="form.rat" :precision="4"></MoneyInput>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="!isTWD">
                        <el-col :sm="16">
                            <el-form-item label="約當台幣" style="margin-top: -15px">
                                <MoneyInput :value="form.amount * form.rat" :disabled="true" suffix="TWD"></MoneyInput>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item v-if="!isTWD" prop="serialNumber">
                        <template slot="label"> 水單號碼<ahTip>銀行匯入匯款編號</ahTip> </template>
                        <el-input v-model="form.serialNumber" :show-word-limit="true" :maxlength="20"></el-input>
                    </el-form-item>
                    <template v-if="isBankShow && !isIncome">
                        <el-form-item prop="refunD_BNK_TPC" label="客戶存簿戶名">
                            <el-input v-model="form.refunD_BNK_TPC"></el-input>
                        </el-form-item>
                        <el-form-item prop="refunD_BNK_BOO" label="客戶存簿銀行">
                            <ah-el-select-bank v-model="form.refunD_BNK_BOO" :branch="form.refunD_BNK_DOO" @branchInput="form.refunD_BNK_DOO = $event"></ah-el-select-bank>
                        </el-form-item>
                        <el-form-item prop="refunD_BNK_ACC" label="客戶存簿帳號">
                            <ah-el-input-bank-acc v-model="form.refunD_BNK_ACC" :bankBoo="form.refunD_BNK_BOO"></ah-el-input-bank-acc>
                        </el-form-item>
                    </template>
                    <el-form-item prop="mem">
                        <template slot="label">入帳備註 </template>
                        <el-input v-model="form.mem" type="textarea" :autosize="{ minRows: 4 }" maxlength="250" show-word-limit />
                    </el-form-item>
                </el-form>
                <div class="button-set">
                    <div class="left-side">
                        <el-button v-if="isEditMode" type="danger" plain @click="onDelete">
                            刪除
                        </el-button>
                    </div>
                    <div class="right-side">
                        <el-button type="" plain @click="onCancel"> 取消 </el-button>
                        <el-button type="primary" class="primary-action" @click="onSubmit">
                            {{ actionText }}
                        </el-button>
                    </div>
                </div>
                <div style="color: #999; font-size: 9pt; margin-top: 10px" v-if="lastEditUser">
                    <span>最後編輯：</span>
                    <span>{{ lastEditUser }}</span>
                    <span style="margin-left: 10px">
                        {{ lastEditDate | dateFormater("YYYY-MM-dd") }}
                    </span>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import ahElSelectBankAccount from '@/components/ui/ahElSelectBankAccount.vue';
import ahElSelectBank from '@/components/ui/ahElSelectBank.vue';
import ahElInputBankAcc from '@/components/ui/ahElInputBankAcc.vue';

export default {
    props: {
        visible: Boolean,
        invoice: {
            type: Object,
            default: () => {},
        },
        editForm: {
            type: Object,
            default: () => {},
        },
    },
    components: { ahElSelectBankAccount, ahElSelectBank, ahElInputBankAcc },
    computed: {
        remainAmt() {
            return this.invoice.amt - this.totalArrival + this.totalRefund;
        },
        totalRefund() {
            return _.chain(this.invoice.incomes)
                .filter((o) => o.flg < 0)
                .sumBy((o) => o.amount)
                .value();
        },
        totalArrival() {
            return _.chain(this.invoice.incomes)
                .filter((o) => o.flg > 0)
                .sumBy((o) => o.amount)
                .value();
        },
        title() {
            return `${this.isEditMode ? '編輯' : '新增'}${this.isIncome ? '入帳' : '退款'}`;
        },
        actionText() {
            return `${this.isEditMode ? '儲存' : '送出'}`;
        },
        typeList() {
            return this.isIncome ? this.arriveTypeList.income : this.arriveTypeList.return;
        },
        lastEditUser() {
            return this.editForm.form?.bankCreateUser;
        },
        lastEditDate() {
            return this.editForm.form?.upD_DAT;
        },
        isEditMode() {
            return this.editForm.form;
        },
        isBankShow() {
            return this.form.receiveIncomeType !== 2;
        },
        isIncome() {
            if (this.flg < 0) return false;
            return true;
        },
        isTWD() {
            return this.invoice.cny === 'TWD';
        },
        isTypeInvoice() {
            return this.invoice.typ === 1;
        },
        rules() {
            return {
                bnK_DAT: [
                    {
                        required: true,
                        message: '請選擇日期',
                        trigger: 'blur',
                    },
                ],
                bnK_SNO: [
                    {
                        required: true,
                        message: '請選擇銀行',
                        trigger: 'change',
                    },
                ],
                amount: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value === 0) {
                                callback(new Error('輸入金額不可為零'));
                            } else callback();
                        },
                        trigger: 'blur',
                    },
                ],
                refunD_BNK_TPC: [
                    {
                        required: true,
                        message: '請選擇輸入客戶存簿戶名',
                        trigger: 'blur',
                    },
                ],
                refunD_BNK_BOO: [
                    {
                        required: true,
                        message: '請選擇輸入客戶存簿銀行',
                        trigger: 'change',
                    },
                ],
                refunD_BNK_ACC: [
                    {
                        required: true,
                        message: '請選擇輸入客戶存簿帳號',
                        trigger: 'blur',
                    },
                ],
                rat: [
                    {
                        required: true,
                        message: '請選擇輸入匯率',
                        trigger: 'blur',
                    },
                ],
                mem: this.isIncome
                    ? []
                    : [
                        {
                            required: true,
                            message: '請輸入退款備註',
                            trigger: 'blur',
                        },
                    ],
            };
        },
        flg() {
            return this.editForm?.flg || 0;
        },
    },
    data() {
        return {
            form: {
                bnK_DAT: moment()
                    .startOf('day')
                    .format('x'),
                receiveIncomeType: 0,
                bnK_SNO: null,
                amount: 0,
                rat: 1,
                serialNumber: undefined,

                refunD_BNK_BOO: null,
                refunD_BNK_DOO: null,
                refunD_BNK_ACC: null,
                refunD_BNK_TPC: null,

                mem: null,
            },
            arriveTypeList: {
                income: [
                    { sno: 0, label: '銀行匯款' },
                    { sno: 1, label: '收現金存銀行' },
                    { sno: 2, label: '收現金存零用金' },
                ],
                return: [
                    { sno: 0, label: '銀行匯款' },
                    { sno: 2, label: '零用現金退費' },
                ],
            },
        };
    },
    methods: {
        onOpen() {
            if (this.editForm.form) this.form = { ...this.editForm.form };
            else {
                this.form.rat = this.getCnyRat();
                this.form.amount = this.isIncome ? this.remainAmt : this.totalArrival;

                // 折讓退回自動帶入
                if (this.editForm.refound) {
                    this.form.amount = this.editForm.refound;
                    this.form.mem = this.editForm.refound === this.invoice.amt ? '退回退款' : '折讓退款';
                }
            }
            this.$nextTick(() => {
                this.$refs.form?.clearValidate();
            });
        },
        onClose(event, reload) {
            if (reload) this.$emit('reload');

            this.$emit('close');
        },
        onClosed() {
            this.form = {
                bnK_DAT: moment()
                    .startOf('day')
                    .format('x'),
                receiveIncomeType: 0,
                bnK_SNO: null,
                amount: 0,
                rat: 1,
                serialNumber: undefined,
                mem: null,
            };
        },

        onCancel() {
            this.onClose();
        },
        onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    if (!this.isBankShow) {
                        this.form.refunD_BNK_BOO = null;
                        this.form.refunD_BNK_DOO = null;
                        this.form.refunD_BNK_ACC = null;
                        this.form.refunD_BNK_TPC = null;
                        this.bnK_SNO = null;
                    }
                    if (this.isEditMode) await this.onSave();
                    else await this.onAdd();

                    this.onClose(null, true);
                }
            });
        },

        async onAdd() {
            const data = {
                ...this.form,
                flg: this.flg,
                bnK_DAT: Number(this.form.bnK_DAT),
                bnK_SNO: this.form.receiveIncomeType === 2 ? null : this.form.bnK_SNO,
                ioo: this.invoice.ioo,
            };
            await this.$api({
                url: '/InvoiceManagemnetPage/AddInvoiceIncome',
                method: 'POST',
                data,
            });
        },
        async onSave() {
            const data = {
                ...this.form,
                flg: this.flg,
                bnK_DAT: Number(this.form.bnK_DAT),
                bnK_SNO: this.form.receiveIncomeType === 2 ? null : this.form.bnK_SNO,
                ioo: this.invoice.ioo,
                sno: this.editForm.form.sno,
            };
            await this.$api({
                url: '/InvoiceManagemnetPage/UpdateInvoiceIncome',
                method: 'POST',
                data,
            });
        },
        async onDelete() {
            try {
                await this.$confirm('確定刪除此筆入帳？', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                });

                await this.$api({
                    url: '/InvoiceManagemnetPage/DeleteInvoiceIncome',
                    method: 'POST',
                    data: { sno: this.editForm.form.sno },
                });
                this.onClose(null, true);
            } catch (e) {
                console.log(e);
            }
        },

        isCashOperationDisabled(sno) {
            if (sno !== 2) return false;
            return this.invoice.cny !== 'TWD';
        },
        getCnyRat() {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === this.invoice.cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },

        applySysCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) {
                this.form.rat = cnyOption.rat;
            } else {
                alert(`找不到該幣別資料：${cny}`);
            }
        },
        disabledDate(date) {
            return this.isIncome ? date.getTime() >= Date.now() : false;
        },
    },
};
</script>

<style lang="scss">
.invoice-arrived-edit-dialog.ah-detail-dialog {
    .info-block {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-end;
        margin-bottom: 30px;
        > * {
            width: fit-content;
            display: flex;
            margin-bottom: 5px;
            &:last-child {
                margin-bottom: 0;
            }
            .money {
                width: 130px;
                margin-right: 10px;
                text-align: right;
            }
        }
    }
    .button-set {
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
    }
    .ah-el-select-bank {
        display: flex;
    }
}
</style>

<style lang="scss">
.invoice-arrived-edit-dialog .el-select {
    width: 100% !important;
}
</style>
